import camelcaseKeys from "camelcase-keys";

import { apiSlice } from "@/lib/rtkquery";
import { ApiResponse, LocationDTO } from "@/types";

type LocationResponse = ApiResponse<LocationDTO>;
type LocationsResponse = ApiResponse<LocationDTO[]>;

const locationApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getLocations: build.query<LocationDTO[], void>({
      query: () => "api/v1/locations",
      transformResponse: (response: LocationsResponse) =>
        camelcaseKeys(response.results),
    }),
    getLocation: build.query<LocationDTO, string>({
      query: (id) => `api/v1/locations/${id}`,
      transformResponse: (response: LocationResponse) =>
        camelcaseKeys(response.results),
    }),
    getLocationsByAuditType: build.query<LocationDTO[], string>({
      query: (auditType) => `api/v1/locations/audit_types/${auditType}`,
      transformResponse: (response: LocationsResponse) =>
        camelcaseKeys(response.results),
    }),
  }),
});

export const {
  useGetLocationQuery,
  useGetLocationsQuery,
  useGetLocationsByAuditTypeQuery,
} = locationApi;
